// public-api.ts
import { environment } from '../../environments/environment';
const BASE_URL = `${environment.apiUrl}`;
const AI_BASE_URL = `${environment.Ai_insight_apiUrl}`;
const AUTH_URL = `${BASE_URL}:t3u1HoXb${environment.apiSuffix || ''}`;
const AUTH_URL2 = `${BASE_URL}:AFDabxbQ${environment.apiSuffix || ''}`;

const CONTEST_URL = `${BASE_URL}:BB6HooOR${environment.apiSuffix || ''}`;

const SUBSCRIB_URL = `${BASE_URL}:p7cV6HxK${environment.apiSuffix || ''}`;
const DEVELOPER_URL = `${BASE_URL}:v5lydYLZ${environment.apiSuffix || ''}`;
const NOTIF_URL = `${BASE_URL}:Aw50otLs${environment.apiSuffix || ''}`;
const ANALYSIS_URL = `${BASE_URL}:p0r8IJso${environment.apiSuffix || ''}`;
const ANALYSIS_URL_Reports = `${BASE_URL}:BowSC_LT${environment.apiSuffix || ''}`;
const CLIENT_DASHBOARD = `${BASE_URL}:KVYQ1PW2${environment.apiSuffix || ''}`;
const TEST_SERVERSIDE_PAGINATION = `${BASE_URL}:nyeA1eF9${environment.apiSuffix || ''}`;


const PRIVACY_URL = `${BASE_URL}:zTQtGzbe`;
const QUIZ_URL = `${BASE_URL}:71iUzbDi${environment.apiSuffix || ''}`;
const COMMON_URL = `${BASE_URL}:W8nua2-z${environment.apiSuffix || ''}`;
const SECTOR_URL = `${BASE_URL}:h3prqsmw${environment.apiSuffix || ''}`;
const USER_MGMT_URL = `${BASE_URL}:yLDe0z5b${environment.apiSuffix || ''}`;
const DASHBOARD_CONTESTS_URL = `${BASE_URL}:oVl64uWz${environment.apiSuffix || ''}`;
const ACTIVITY_LOGS_URL = `${BASE_URL}:hVlpuC4-${environment.apiSuffix || ''}`;
// Campaign Companion (WhatsApp bot) API group.
const COMPANION_URL = `${BASE_URL}:jKhRtMpW${environment.apiSuffix || ''}`;
export const PublicApi = {
  // ── Campaign Companion (WhatsApp) ──
  COMPANION_NUMBERS_LIST: COMPANION_URL + '/whatsapp_numbers_list',
  COMPANION_NUMBER_TOGGLE: COMPANION_URL + '/whatsapp_number_toggle',
  COMPANION_NUMBER_REMOVE: COMPANION_URL + '/whatsapp_number_remove',
  COMPANION_SET_ENABLED: COMPANION_URL + '/whatsapp_admin_set_companion',
  // Account-level master switch (separate from the per-number toggles above).
  COMPANION_IS_ENABLED: COMPANION_URL + '/is_companion_enabled',
  COMPANION_ENABLE: COMPANION_URL + '/enable_campaign_companion',
  // Companion activity/audit log feed (GET, query params).
  COMPANION_LOGS: COMPANION_URL + '/whatsapp_logs',
  WHATSAPP_CONVERSATION_LOG: COMPANION_URL + '/whatsapp_conversation_log',
  WHATSAPP_PENDING_CONTESTS: COMPANION_URL + '/whatsapp_pending_contests',
  LOGIN: AUTH_URL + '/auth/login',
  SIGNUP: AUTH_URL + '/auth/signup',
  SOCIAL_LOGIN: AUTH_URL + '/auth/google/continue',
  RESET_PASSWORD: AUTH_URL + '/reset-password',
  USER_RESET_PASSWORD: AUTH_URL + '/auth/reset_password',
  SEND_RESET_LINK: AUTH_URL + '/forgot_password',
  GET_PRIVACY_POLICY: PRIVACY_URL + '/privacy_policy',
  GET_TERMS_CONDITION: PRIVACY_URL + '/terms_condition',
  LOGOUT: AUTH_URL + '/auth/admin/logout',
  SEND_OPT: AUTH_URL + '/auth/send-client-otp',
  VERIFY_OPT: AUTH_URL + '/auth/verify-client-otp',
  GET_ME: AUTH_URL + '/auth/me',
  UPDATE_LANGUAGE: AUTH_URL + '/auth/language',
  RESEND_EMAIL: BASE_URL + 'ResendEmail',
  SET_COMPANY_DETAILS: AUTH_URL2 + '/company_as_client',

  REQUEST_CONTEST_REMOVE_LEVEL: CONTEST_URL + '/levels',
  REQUEST_CONTEST_REMOVE_PRIZE: CONTEST_URL + '/contest_prize',

  GET_USER_COMPANY: AUTH_URL2 + '/all_company',
  GET_CONTESTS_LIST: CONTEST_URL + '/contest_list',
  GET_ALL_CONTESTS: CONTEST_URL + '/all_contests',
  GET_DRAFT_CONTESTS_LIST: CONTEST_URL + '/draft_contest/list',
  REQUEST_CONTEST: CONTEST_URL + '/request_contest',
  REQUEST_CONTEST_CLIENT: CONTEST_URL + '/request_contest_client',
  SAVE_CONTEST_DRAFT: CONTEST_URL + '/save_contest_draft',
  REQUEST_CONTEST_LUQTA: TEST_SERVERSIDE_PAGINATION + '/request_contest',
  REQUEST_CONTEST_LIST: CONTEST_URL + '/request_contest/list',
  TEST_PAGINATION: TEST_SERVERSIDE_PAGINATION + '/get_contests',
  CONTEST_REPORT: TEST_SERVERSIDE_PAGINATION + '/contest_report',
  DELETE_CONTEST: CONTEST_URL + '/contest/remove',
  EDIT_CONTEST: CONTEST_URL + '/contest/configure',
  GET_SINGLE_CONTEST: CONTEST_URL + '/contest',
  CONTEST_PERFORMANCE: CONTEST_URL + '/Contest_Performance',
  // ── Web QR (per-contest QR instances) ──
  QR_INSTANCE_LIST: CONTEST_URL + '/qr_instance_list',
  QR_INSTANCE_CREATE: CONTEST_URL + '/qr_instance_create',
  QR_INSTANCE_UPDATE: CONTEST_URL + '/qr_instance_update',
  WEB_QR_INSTANCE_PARTICIPANTS: ANALYSIS_URL_Reports + '/WebQRInstanceParticipants',
  // Self-publish for web_access plans — the Web QR equivalent of PUBLISH_CONTEST.
  WEB_QR_SELF_APPROVE: CONTEST_URL + '/web_qr_self_approve',
  EDIT_CONTEST_CLIENT: CONTEST_URL + '/contest_client',
  REQUEST_CONTEST_SET_LEVEL: CONTEST_URL + '/request_contest/set_level',
  REQUEST_CONTEST_SET_PRIZE: CONTEST_URL + '/request_contest/set_prize',
  CATEGORIES_LOOKUP: CONTEST_URL + '/categories_lookup',
  CONTEST_CATEGORY_LOOKUP: CONTEST_URL + '/user_interest',
  CONTEST_BY_COUNTRY: CONTEST_URL + '/contest_by_country',
  CONTEST_OVERVIEW: CONTEST_URL + '/contest_over_view',
  PUBLISH_CONTEST: CONTEST_URL + '/publish_client_contest',
  WINNER_OVERRIDE: CONTEST_URL + '/winner_override',
  WINNER_OVERRIDE_AUDIT_LOG: CONTEST_URL + '/winner_override_audit_log',

  GET_PARTICIPANT: CONTEST_URL + '/participants',
  // sssss
  GET_Total_PARTICIPANT: CONTEST_URL + '/get_total_participates_client',

  PURCHASED_PLAN: SUBSCRIB_URL + '/user/purchased_plan',
  GET_PARTICIPANTS_LIST: ANALYSIS_URL_Reports + '/Client_Side_All_Participants',

  FREE_PLAN: SUBSCRIB_URL + '/freePlan',
  CHOOSE_SUBSCRIPTION_PLAN: SUBSCRIB_URL + '/subscribe_user',
  GET_SUBSCRIPTION_PLAN: SUBSCRIB_URL + '/active_plans',
  GET_BILLING_PLANS: SUBSCRIB_URL + '/billing_payment',
  CHECK_PAYMENT: SUBSCRIB_URL + '/check_payment',
  RENEWAL_PAYMENT_LINK: SUBSCRIB_URL + '/renewal_payment_link',
  CASH_PAYMENT: SUBSCRIB_URL + '/cashpayment',
  BANK_CARD: SUBSCRIB_URL + '/bank_card',
  EDIT_BANK_CARD: SUBSCRIB_URL + '/bank_card/edit',
  DELETE_BANK_CARD: SUBSCRIB_URL + '/bank_card/delete',
  PAYMENT_REPORT: SUBSCRIB_URL + '/billing/report',
  PAYMENT_REPORT_PDF: SUBSCRIB_URL + '/billing/report_pdf',
  CHECK_PAYMENT_BY_USER: SUBSCRIB_URL + '/check_payment_by_user',
  ENTERPRISE_PLAN: SUBSCRIB_URL + '/enterprise',
  BILLING_DISCOUNT: SUBSCRIB_URL + '/get_discount_history',
  INVOICE_DETAILS: SUBSCRIB_URL + '/invoice_details',

  // SDK Applications
  SDK_APPLICATIONS: SUBSCRIB_URL + '/applications',
  SDK_APPLICATIONS_LIST: SUBSCRIB_URL + '/user_applications_list',
  SDK_GENERATE_API_KEY: SUBSCRIB_URL + '/generate_api_key',
  CHECK_SDK_PAYMENT: SUBSCRIB_URL + '/check_sdk_payment',

  GET_DEVELOPER_API_KEY: DEVELOPER_URL + '/third_party_user_api_keys',
  GET_NOTIFICATION: NOTIF_URL + '/notif',
  UPDATE_NOTIFICATION: NOTIF_URL + '/notification_update_client',
  MARK_ALL_NOTIFICATIONS_READ: NOTIF_URL + '/mark_allnotifications_read',
  BASE_TO_IMAGE: NOTIF_URL + '/baseToImage',

  // Analysis
  GET_ANALYSIS: ANALYSIS_URL + '/analysisreportlist',
  ANALYSIS_URL_Reports: ANALYSIS_URL_Reports + '/Contest_Summary_Client',
  ANALYSIS_URL_Reports_DETAIL: ANALYSIS_URL_Reports + '/individual_contest_report_client',
  GET_CONTEST_MONITORING: ANALYSIS_URL + '/contest_monitoring',

  // dashboard
  CLIENT_DASHBOARD: CLIENT_DASHBOARD + '/client_dash',
  DASH_BAR_CHART: CLIENT_DASHBOARD + '/bar_chart_data',
  DASH_COUNTRY_DATA: CLIENT_DASHBOARD + '/country_data',
  DASH_GENDER_DATA: CLIENT_DASHBOARD + '/genderData',
  DASH_CONTEST_STATS: CLIENT_DASHBOARD + '/get_contest_stats',
  DASH_LINE_CHART: CLIENT_DASHBOARD + '/line_chart',
  DASH_PARTICIPANTS: CLIENT_DASHBOARD + '/participants_data',
  SUBSCRIPTION_DETAIL: CLIENT_DASHBOARD + '/subscription_detail',
  DASH_CONTEST_OVERVIEW: CLIENT_DASHBOARD + '/Contest_Overview',
  // Web QR scan reporting — filtered by contest, label and date range, paginated.
  WEB_QR_REPORT: CLIENT_DASHBOARD + '/web_qr_report',
  CONTEST_DETAIL_OVERVIEW: CLIENT_DASHBOARD + '/contest_detail_overview',
  GET_ALL_PARTICIPANTS: CLIENT_DASHBOARD + '/participants',
  ALL_PARTICIPANTS: CLIENT_DASHBOARD + '/all_participants',
  UNIQUE_PARTICIPANTS: CLIENT_DASHBOARD + '/unique_participants',
  UNIQUE_PARTICIPANTS_V2: CLIENT_DASHBOARD + '/unique_participants_v2',
  UNIQUE_CONTEST_PARTICIPANTS: CLIENT_DASHBOARD + '/unique_contest_participants',
  UNIQUE_PARTICIPANTS_CONTEST_LEVELS: CLIENT_DASHBOARD + '/unique_participants_contest_levels',
  CONTEST_LEVEL_COMPLETION_METRICS: CLIENT_DASHBOARD + '/contest_level_completion_metrics',
  // AI INSIGHT APIS

  // GET_AI_INSIGHT: AI_BASE_URL + '/insights',

  // Quiz APIs
  GET_QUIZZES: QUIZ_URL + '/quizzes_client',
  GET_QUIZ_BY_ID: QUIZ_URL + '/quizzes',
  QUIZ_UPSERT: QUIZ_URL + '/quiz_upset',
  DELETE_QUIZ: QUIZ_URL + '/quizzes',
  GET_QUIZZES_LOOKUP: QUIZ_URL + '/quizzes_look_up_client',

  // Common/Lookup APIs
  GET_COUNTRIES: COMMON_URL + '/country',

  // Sector APIs
  GET_SECTORS: SECTOR_URL + '/sector',

  // User Management APIs
  CREATE_SUBUSER: USER_MGMT_URL + '/create/my/subusers',
  GET_SUBUSERS: USER_MGMT_URL + '/get/my/subusers',
  DELETE_SUBUSER: USER_MGMT_URL + '/delete_subuser',
  VERIFY_SUBUSER_PASSWORD: USER_MGMT_URL + '/verify_subuser_password',
  UPDATE_SUBUSER_PASSWORD: USER_MGMT_URL + '/update_subuser_password__',
  UPDATE_SUBUSER: USER_MGMT_URL + '/update_subuser',
  EDIT_SUBUSER: USER_MGMT_URL + '/edit_subuser',

  // Dashboard Contests
  GET_DASHBOARD_CONTESTS: DASHBOARD_CONTESTS_URL + '/get_contests',
  GET_BUSINESS_SUBJECTS: DASHBOARD_CONTESTS_URL + '/business_subject',
  CONTEST_LEADERBOARD: DASHBOARD_CONTESTS_URL + '/contest_leaderboard',
  GLOBAL_LEVEL_SETTINGS: DASHBOARD_CONTESTS_URL + '/global_level_settings',

  // Activity Logs
  ACTIVITY_LOGS: ACTIVITY_LOGS_URL + '/create_activity_log_for_client',

  // Client Branding & Domain APIs
  BRANDING_LIST: CLIENT_DASHBOARD + '/branding/list',
  BRANDING_CREATE: CLIENT_DASHBOARD + '/branding/create',
  BRANDING_UPDATE: CLIENT_DASHBOARD + '/branding/update',
  BRANDING_SET_DEFAULT: CLIENT_DASHBOARD + '/branding/set_default',
  DOMAIN_LIST: CLIENT_DASHBOARD + '/domain/list',
  DOMAIN_CREATE: CLIENT_DASHBOARD + '/domain/create',
  DOMAIN_UPDATE: CLIENT_DASHBOARD + '/domain/update',
  DOMAIN_VERIFY: CLIENT_DASHBOARD + '/domain/verify',
  DOMAIN_DELETE: CLIENT_DASHBOARD + '/domain/delete',

  // 3D Models — upload is multipart/form-data (`content` file + `name`), list is per-user.
  UPLOAD_MODEL: CLIENT_DASHBOARD + '/upload/model',
  MY_MODELS: CLIENT_DASHBOARD + '/my_models',

} as const;

// export const productDetails  = 'api/v1/product/';
